import { IRemoteContent } from "@/store/modules/newsItems/types.d";

export default (
  remoteContent: IRemoteContent[],
  itemClass: string
): string | null => {
  if (remoteContent.length) {
    if (itemClass === "graphic") {
      const graphicPreviews = remoteContent.filter(
        content => content.contentType === "image/jpeg"
      );
      const colourPreview = graphicPreviews.filter(
        preview =>
          preview.colourIndicator && preview.colourIndicator.endsWith("colour")
      );
      return colourPreview.length
        ? colourPreview[0].residref
        : graphicPreviews[0].residref;
    }
    return remoteContent[0].residref;
  }
  return null;
};
